import {
  SYSTEM_LIST_REQUEST,
  DASHBOARD_LIST_REQUEST,
  DASHBOARD_LIST_SUCCESS,
  ACTIVATION_LIST_REQUEST,
  ALERT_LIST_REQUEST,
  SEARCH_LIST_REQUEST,
  SYSTEM_LIST_SUCCESS,
  ACTIVATION_LIST_SUCCESS,
  ALERT_LIST_SUCCESS,
  SEARCH_LIST_SUCCESS,
  RESET_SEARCH_LIST,
  REQUEST_FAILURE,
  GET_ENLM_FEEDBACK_REQUEST,
  GET_ENLM_FEEDBACK_SUCCESS,
  GET_ENLM_FEEDBACK_FAILURE,
  ADD_ENLM_FEEDBACK_REQUEST,
  ADD_ENLM_FEEDBACK_SUCCESS,
  ADD_ENLM_FEEDBACK_FAILURE,
  GET_SYSTEM_SAVED_SEARCH_REQUEST,
  GET_SYSTEM_SAVED_SEARCH_SUCCESS,
  GET_SYSTEM_SAVED_SEARCH_FAILURE,
  GET_SERVICE_MANAGER_CASES_FAILURE,
  GET_SERVICE_MANAGER_CASES_REQUEST,
  GET_SERVICE_MANAGER_CASES_SUCCESS
} from './constants';

let initialState = {
  systemList: {},
  dashboardList: {},
  activationList: {},
  alertList: {},
  searchList: {},
  systemLoading: false,
  dashboardLoading: false,
  activationLoading: false,
  alertLoading: false,
  enlmFeedbacks: [],
  systemSavedSearch: {},
  serviceManagerCases: {},
  providerStatusDetails: {}
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SYSTEM_LIST_REQUEST:
      return { ...state, systemLoading: true };
    case SYSTEM_LIST_SUCCESS:
      return { ...state, systemList: action.systemList, systemLoading: false };
    case DASHBOARD_LIST_REQUEST:
      return { ...state, dashboardLoading: true };
    case DASHBOARD_LIST_SUCCESS:
      return { ...state, dashboardList: action.dashboardList, dashboardLoading: false };
    case ACTIVATION_LIST_REQUEST:
      return { ...state, activationLoading: true };
    case ACTIVATION_LIST_SUCCESS:
      return { ...state, activationList: action.activationList, activationLoading: false };
    case ALERT_LIST_REQUEST:
      return { ...state, alertLoading: true };
    case ALERT_LIST_SUCCESS:
      return { ...state, alertList: action.alertList, alertLoading: false };
    case SEARCH_LIST_REQUEST:
      return { ...state };
    case SEARCH_LIST_SUCCESS:
      return { ...state, searchList: action.searchList };
    case RESET_SEARCH_LIST:
      return { ...state, searchList: {} };
    case REQUEST_FAILURE:
      return {
        ...state,
        systemLoading: false,
        activationLoading: false,
        alertLoading: false,
        dashboardLoading: false
      };
    case GET_ENLM_FEEDBACK_REQUEST:
      return { ...state };
    case GET_ENLM_FEEDBACK_SUCCESS:
      return { ...state, enlmFeedbacks: action.enlmFeedbacks };
    case GET_ENLM_FEEDBACK_FAILURE:
      return { ...state };
    case ADD_ENLM_FEEDBACK_REQUEST:
      return { ...state };
    case ADD_ENLM_FEEDBACK_SUCCESS:
      return { ...state };
    case ADD_ENLM_FEEDBACK_FAILURE:
      return { ...state };
    case GET_SYSTEM_SAVED_SEARCH_REQUEST:
      return { ...state };
    case GET_SYSTEM_SAVED_SEARCH_SUCCESS:
      return { ...state, systemSavedSearch: action.systemSavedSearch };
    case GET_SYSTEM_SAVED_SEARCH_FAILURE:
      return { ...state };
    case GET_SERVICE_MANAGER_CASES_REQUEST:
      return { ...state };
    case GET_SERVICE_MANAGER_CASES_SUCCESS:
      return { ...state, serviceManagerCases: action.serviceManagerCases };
    case GET_SERVICE_MANAGER_CASES_FAILURE:
      return { ...state };
    default:
      return state;
  }
}

export default reducer;
